export default __webpack_public_path__ + "static/media/03_Auctioneers-Commercial-EschweilerPhotography_M1A9628.f6c55a20.jpg";